import { LocalCache, StorageKey } from "../../../../../shared/cache/LocalCache"

export type CheckInPrefs = { printGuestCard: boolean; sendNotification: boolean }

export const defaultCheckInPrefs: CheckInPrefs = { printGuestCard: false, sendNotification: true }

export function loadCheckInPrefs(): CheckInPrefs {
    const raw = LocalCache().get(StorageKey.SERVICE_CENTER_GUEST_CHECK_IN_PREFS)
    if (!raw) {
        return defaultCheckInPrefs
    }
    try {
        const parsed: unknown = JSON.parse(raw)
        const obj = typeof parsed === "object" && parsed !== null ? (parsed as Record<string, unknown>) : {}
        return {
            printGuestCard: typeof obj["printGuestCard"] === "boolean" ? obj["printGuestCard"] : false,
            sendNotification: typeof obj["sendNotification"] === "boolean" ? obj["sendNotification"] : true,
        }
    } catch {
        return defaultCheckInPrefs
    }
}

export function saveCheckInPrefs(prefs: CheckInPrefs) {
    LocalCache().set(StorageKey.SERVICE_CENTER_GUEST_CHECK_IN_PREFS, JSON.stringify(prefs))
}
